import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import LoginJWT from '../../components/authentication/LoginJWT';
import DashboardFooter from '../../components/dashboard/DashboardFooter';
import LogoWithName from '../../components/logos/LogoWithName';

const Login = () => {
  const [error, setError] = useState('');
  const location = useLocation();

  // Check for error message in location state
  useEffect(() => {
    if (location.state?.message) {
      setError(location.state.message);
      window.history.replaceState({}, '', '/login'); // Clear the state to prevent showing the error again on refresh
    }
  }, [location.state]);

  return (
    <>
      <Helmet>
        <title>Login | Sunstone Credit</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          py: 5,
        }}
      >
        <Paper
          sx={{
            pt: { xs: 2, sm: 3, md: 7.75 },
            pb: { xs: 2, sm: 4, md: 8.5 },
            px: { xs: 3, sm: 7, md: 14 },
            width: { xs: 300, sm: 450, md: 720 },
            borderRadius: 1.5,
            textAlign: { xs: 'center', md: 'unset' },
            minHeight: '660px',
          }}
        >
          <Box display="flex" justifyContent="center">
            <a href={__landingUrl__}>
              <LogoWithName height={41.5} />
            </a>
          </Box>
          <LoginJWT customError={error} />
        </Paper>
        <Box sx={{ display: { md: 'block', xs: 'none' } }}>
          <DashboardFooter />
        </Box>
      </Box>
    </>
  );
};

export default Login;
